import React from 'react';
import { Button } from '@mui/material';

const Pagination = ({
  currentPage,
  totalPages,
  onFirstPage,
  onPrevPage,
  onNextPage,
  onLastPage
}) => {
  return (
    <div className="pagination">
      <Button
        variant="outlined"
        size="small"
        onClick={onFirstPage}
        disabled={currentPage === 1}
        className="me-2"
      >
        First
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={onPrevPage}
        disabled={currentPage === 1}
        className="me-2"
      >
        Prev
      </Button>
      <span className="mx-2 align-self-center">
        Page {currentPage} of {totalPages}
      </span>
      <Button
        variant="outlined"
        size="small"
        onClick={onNextPage}
        disabled={currentPage === totalPages}
        className="me-2"
      >
        Next
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={onLastPage}
        disabled={currentPage === totalPages}
      >
        Last
      </Button>
    </div>
  );
};

export default Pagination;
